import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { allowedConnectOptionsSchema } from '../../../constants/common';
import { Box, Button, Divider, Text } from '@streamelements/frontend-ui';

const searchParamsSchema = z.object({
  provider: allowedConnectOptionsSchema,
  destinationId: z.string(),
});

export const Route = createFileRoute('/_authenticated/onboarding/setup-multistreaming/_layout/success')({
  component: SuccessPage,
  validateSearch: searchParamsSchema,
});

function SuccessPage() {
  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1.5rem',
        height: '100%',
      }}
    >
      <Box css={{ px: '1rem' }}>
        <Text.Subtitle weight="bold">Controlling outputs</Text.Subtitle>
        <Text.Body variant="caption" css={{ color: '$textPrimary50' }}>
          You can easily toggle outputs to stop or restart your multi-stream live connection per channel
        </Text.Body>
      </Box>

      <Box
        css={{
          maxWidth: 320,
          width: '100%',
          aspectRatio: '1.55/1',
          overflow: 'hidden',
          br: '0.25rem',
          mx: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          video: {
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          },
        }}
      >
        <video src="/multistreaming-onboarding-toggle-preview.mp4" autoPlay loop muted />
      </Box>

      <Divider css={{ my: 0, mx: '1rem', width: 'calc(100% - 2rem)' }} />

      <Box css={{ textAlign: 'center', flex: 1 }}>
        <Text.Subtitle weight="bold">Have more channels to connect to?</Text.Subtitle>
        <Text.Body
          variant="caption"
          css={{
            color: '$textPrimary50',
            mb: '1rem',
            maxWidth: 280,
            mx: 'auto',
          }}
        >
          SE.Live allows you to create as many canvases and stream to as many platforms as you wish or just record
        </Text.Body>

        <Button density="compact" variant="outlined" asChild>
          <Link to="/onboarding/setup-multistreaming">Add another channel</Link>
        </Button>
      </Box>

      <Box
        css={{
          display: 'flex',
          justifyContent: 'center',
          gap: '1rem',
          bgc: '$uiQuaternary',
          padding: '0.5rem',
        }}
      >
        <Button density="compact" color="neutral" css={{ width: '100%' }} asChild>
          <Link to="/onboarding/setup-multistreaming/finish">Next</Link>
        </Button>
      </Box>
    </Box>
  );
}
